import { ApplicationConfig, inject } from '@angular/core'
import { InMemoryCache } from '@apollo/client/core'
import { provideApollo } from 'apollo-angular'
import { HttpLink } from 'apollo-angular/http'
import { environment } from '@app-env/environment'

export const graphqlProvider: ApplicationConfig['providers'] = [
    provideApollo(() => {
        const httpLink = inject(HttpLink)

        return {
            link: httpLink.create({
                uri: `${environment.api.schema}://${environment.api.host}/${environment.api.graphqlPath}`,
            }),
            cache: new InMemoryCache(),
        }
    }),
]
